<script setup lang="ts">
import type { ButtonProps } from './types'
import { Primitive } from 'radix-vue'

const props = withDefaults(defineProps<ButtonProps>(), {
  as: 'button',
  asChild: false,
})
</script>

<template>
  <Primitive v-bind="props">
    <slot />
  </Primitive>
</template>
